import Vue from 'vue'
import Vuex from 'vuex'
import Vue2TouchEvents from 'vue2-touch-events'
import VueObserveVisibility from 'vue-observe-visibility'
import WayfinderVueComponents from '@3dwayfinder/wayfinder-vue-components';
import { loadWayfinder } from '@3dwayfinder/wayfinder-vue-components';

import App from './App.vue'
import './registerServiceWorker'
import "./css/index.css"

Vue.use(Vuex);
Vue.use(VueObserveVisibility);
Vue.use(Vue2TouchEvents, {
  tapTolerance: 15,
  touchHoldTolerance: 600,
  swipeTolerance: 100,
  longTapTimeInterval: 600,
  touchClass: 'wf-touch'
});

Vue.config.productionTip = false

// ------------------------
// ✅ CUSTOM MOCK LANGUAGES FOR LOCAL DEVELOPMENT
// ------------------------
if (process.env.NODE_ENV === "development") {
  

  window.wfConfig = window.wfConfig || {};
  window.wfConfig.languages = [
    { name: "et", getName: () => "et", getNativeName: () => "Eesti" },
    { name: "en", getName: () => "en", getNativeName: () => "English" },
    { name: "ru", getName: () => "ru", getNativeName: () => "Русский" },
  ];
}
// ------------------------


const WF_MAP_TYPE = "2d";
const WF_PROJECT = "028d6e9d11ec9e03459fd023e7138cc9";
const WF_API = "dev";

const store = new Vuex.Store({
  state: {
    appName: "Wayfinder Vue Components",
    currentPOI: null,
    currentGroup: null,
    defaultGroup: null,
    searchVisible: false,
    currentTab: "groups",
    activities: [],
    log: []
  },
  mutations: {
    setPOI (state, poi) {
      state.currentPOI = poi;
    },
    setGroup (state, group ) {
      state.currentGroup = group;
    },
    setDefaultGroup (state, group ) {
      state.defaultGroup = group;
    },
    showSearch (state, show) {
      state.searchVisible = show;
    },
    setTab (state, tab) {
      state.currentTab = tab;
    },
    activities (state, activities) {
      state.activities = activities;
    },
    pushLog (state, log) {
      if (state.log.length > 25) {
        state.log.shift();
      }
      state.log.push(log);
    }
  },
  actions: {
    setPOI : (context, poi) => {
      context.commit('setPOI', Object.freeze(poi));
    },
    setGroup : (context, group) => {
      context.commit('setGroup', Object.freeze(group));
    },
    setDefaultGroup : (context, group) => {
      context.commit('setDefaultGroup', Object.freeze(group));
    },
    showSearch : (context, show) => {
      context.commit('showSearch',  show);
    },
    setTab : (context, show) => {
      context.commit('setTab', show);
    },
    pushLog : (context, log) => {
      context.commit('pushLog', log);
    }
  }
})

loadWayfinder(WF_MAP_TYPE, WF_API, loadVue);

if (process.env.NODE_ENV === "development") {
  const originalWarn = console.warn;
  console.warn = (...args) => {
    const msg = args[0]?.toString() || '';
    if (msg.includes('WFDate') || msg.includes('keyboard layout') || msg.includes('Input field not found')) {
      return; // Suppress these specific warnings
    }
    originalWarn.apply(console, args);
  };
}

// Suppress Wayfinder warnings and debug logs in development
if (process.env.NODE_ENV === "development") {
  const originalWarn = console.warn;
  const originalLog = console.log;
  
  console.warn = (...args) => {
    const msg = args[0]?.toString() || '';
    if (msg.includes('WFDate') || msg.includes('keyboard layout') || msg.includes('Input field not found')) {
      return;
    }
    originalWarn.apply(console, args);
  };
  
  console.log = (...args) => {
    const msg = args[0]?.toString() || '';
    // Suppress Wayfinder debug logs
    if (msg.includes('resize') || 
        msg.includes('render') || 
        msg.includes('buildings') ||
        msg.includes('createOverlays') ||
        msg.includes('runDefaultActions') ||
        msg.includes('Device created') ||
        msg.includes('Device function') ||
        msg.includes('LocationManager')) {
      return;
    }
    originalLog.apply(console, args);
  };
}

function loadVue () {
  new Vue({
    store,
    render: h => h(App),
    created () {
      Vue.use(WayfinderVueComponents, this.$store, WF_MAP_TYPE, WF_PROJECT, WF_API)
    }
  }).$mount('#app')
}
